/* Candela Shop the look — hotspot popovers (open one at a time, click outside / Escape closes)
   and navigation of the popover cards. Sections: candela-shop-the-look.liquid */

(function () {
  function closeAll(except) {
    document.querySelectorAll('.candela-look__hotspot.is-open').forEach(function (h) {
      if (h !== except) {
        h.classList.remove('is-open');
        h.querySelector('.candela-look__pin').setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* The popover opens above and centred on the pin. Flip it below when the
     pin sits too high for it to fit, and pull it in from a side edge when it
     would spill out of the stage. Measured, so a phone stage and a desktop
     stage both get it right. */
  function placeHotspots(root) {
    (root || document).querySelectorAll('.candela-look__hotspot').forEach(function (h) {
      var stage = h.closest('.candela-look__stage');
      var pop = h.querySelector('.candela-look__popover');
      if (!stage || !pop) return;
      var x = parseFloat(getComputedStyle(h).getPropertyValue('--x')) || 50;
      var y = parseFloat(getComputedStyle(h).getPropertyValue('--y')) || 50;
      var sw = stage.clientWidth, sh = stage.clientHeight;
      var pw = pop.offsetWidth, ph = pop.offsetHeight;
      var px = sw * x / 100, py = sh * y / 100;
      var gap = 1.25 * parseFloat(getComputedStyle(document.documentElement).fontSize);
      h.classList.toggle('candela-look__hotspot--top', py - gap - ph < 0);
      h.classList.toggle('candela-look__hotspot--right', px + pw / 2 > sw);
      h.classList.toggle('candela-look__hotspot--left', px - pw / 2 < 0);
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { placeHotspots(); }, 150);
  });

  document.addEventListener('click', function (e) {
    var pin = e.target.closest('.candela-look__pin');
    if (pin) {
      var hotspot = pin.closest('.candela-look__hotspot');
      var open = !hotspot.classList.contains('is-open');
      closeAll(hotspot);
      hotspot.classList.toggle('is-open', open);
      pin.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var popover = e.target.closest('.candela-look__popover');
    if (popover && popover.dataset.href) {
      if (e.metaKey || e.ctrlKey) {
        window.open(popover.dataset.href, '_blank', 'noopener');
      } else {
        window.location.href = popover.dataset.href;
      }
      return;
    }

    if (!e.target.closest('.candela-look__hotspot')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { placeHotspots(); });
  } else {
    placeHotspots();
  }
  document.addEventListener('shopify:section:load', function (e) { placeHotspots(e.target); });
})();
